import React, { useEffect, useState } from 'react';
import moment from 'moment';
import axios from 'axios';
import { Tooltip } from 'bootstrap';
import { FaSearch } from "react-icons/fa";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver"; 
import { MdLocalPrintshop } from "react-icons/md";

const AttReport = () => {
  const [searchFilter, setSearchFilter] = useState('');
  const [selectedMonth, setSelectedMonth] = useState(moment().format('YYYY-MM'));
  const [report, setReport] = useState([]);

  
  const mapTypeToStatus = (type) => {
    switch (type?.toLowerCase()) {
      case 'present': return 'P';
      case 'absent': return 'A';
      case 'half day': return 'H';
      case 'leave': return 'L';
      default: return '-';
    }
  };



const fetchAttendance = async () => {
  try {
    if (!selectedMonth) {
      alert("Please select a month");
      return;
    }

    const res = await axios.get(
      'https://api.skyguard.group/api/fetch-attendance',
      {
        params: { month: selectedMonth },
      }
    );

    const data = res.data.data || [];
    console.log("Raw API Data:", data);

    const startOfMonth = moment(selectedMonth).startOf('month');
    const endOfMonth = moment(selectedMonth).endOf('month');

    const allDates = [];
    let currentDate = startOfMonth.clone();

    while (currentDate.isSameOrBefore(endOfMonth)) {
      allDates.push(currentDate.format('YYYY-MM-DD'));
      currentDate.add(1, 'day');
    }

    const grouped = {};

    data.forEach((item) => {
      const empId = item.emp_id;

      if (!grouped[empId]) {
        grouped[empId] = {
          id: item.id,
          code: item.emp_id,
          name: item.emp_name,
          type:item.type,
          attendance: {},
        };

        // Pre-fill all days as Absent
        allDates.forEach((date) => {
          grouped[empId].attendance[date] = {
            status: "",
            checkIn: "-",
            checkOut: "-",
            hours: "-",
          };
        });
      }

      // ✅ FIXED HERE
      const dateKey = moment(item.date).format('YYYY-MM-DD');
      const status = mapTypeToStatus(item.type);

      let workedHours = "-";

      if (item.check_in && item.check_out) {
        const checkIn = moment(`${item.date} ${item.check_in}`);
        let checkOut = moment(`${item.date} ${item.check_out}`);

        if (checkOut.isBefore(checkIn)) {
          checkOut.add(1, "day");
        }

        const duration = moment.duration(checkOut.diff(checkIn));
        workedHours = `${Math.floor(duration.asHours())}h ${duration.minutes()}m`;
      }

      grouped[empId].attendance[dateKey] = {
        status,
        checkIn: item.check_in
          ? moment(`${item.date} ${item.check_in}`).format("hh:mm A")
          : "-",
        checkOut: item.check_out
          ? moment(`${item.date} ${item.check_out}`).format("hh:mm A")
          : "-",
        hours: workedHours,
      };
    });

    setReport(Object.values(grouped));
    console.log("Final Report:", Object.values(grouped));

  } catch (error) {
    console.error("Error fetching attendance:", error);
  }
};



  useEffect(() => { fetchAttendance(); }, [selectedMonth]);

  // Initialize Bootstrap tooltips after rendering
  useEffect(() => {
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    tooltipTriggerList.forEach((el) => new Tooltip(el, { trigger: 'hover', html: true }));
  }, [report, selectedMonth, searchFilter]);

  const daysInMonth = moment(selectedMonth).daysInMonth();
  const daysArray = Array.from({ length: daysInMonth }, (_, i) => i + 1);

  const getAttendanceInfo = (date, record) => {
    const formattedDate = moment(`${selectedMonth}-${date}`, 'YYYY-MM-DD').format('YYYY-MM-DD');
    return record.attendance[formattedDate] || { status: '-' };
  };

  const monthName = moment(selectedMonth, 'YYYY-MM').format('MMMM');
  const year = moment(selectedMonth, 'YYYY-MM').format('YYYY');

  const filteredReport = report.filter(
    (emp) =>
      emp.name.toLowerCase().includes(searchFilter.toLowerCase()) ||
      emp.code.toLowerCase().includes(searchFilter.toLowerCase())
  );

  const handleExportExcel = () => {
    const table = document.getElementById("exportTable");
  
    if (!table) return;
  
    const worksheet = XLSX.utils.table_to_sheet(table);
    const workbook = XLSX.utils.book_new();
  
    XLSX.utils.book_append_sheet(workbook, worksheet, "Stock Report");
  
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
  
    const data = new Blob([excelBuffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });
  
    saveAs(data, "Attendance_Report.xlsx");
  };

  return (
    <div className='main-section'>
      <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
        <h3 className='my-3 fw-bold fs-5 golos'>Attendance Report</h3>

        {/* Filters */}
        <div className='row gx-3 gy-2 align-items-center mb-3'>
          <div className='col-md-4'>
            <label className='form-label fw-medium'>Search:</label>
            <input
              type='text'
              className='form-control'
              placeholder='Search...'
              value={searchFilter}
              onChange={(e) => setSearchFilter(e.target.value)}
            />
          </div>
          <div className='col-md-3'>
            <label className='form-label fw-medium'>Select Month:</label>
            <input
              type='month'
              className='form-control'
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(e.target.value)}
            />
          </div>
          <div className='col-md-5 d-flex justify-content-end'>
            <h6><span className='text-success'>P</span> - Present</h6>
            <h6 className='ms-3'><span className='text-danger'>A</span> - Absent</h6>
            <h6 className='ms-3'><span className='text-primary'>H</span> - Half Day</h6>
            <h6 className='ms-3'><span className='text-warning'>L</span> - Leave</h6>
          </div>
        </div>

        <h5 className='text-primary fw-bold bg-white p-3 rounded border shadow-sm mb-4 text-center'>
          Attendance for: <span className='text-dark'>{monthName} - {year}</span>
        </h5>

        <div className="col-md-12 d-flex justify-content-end align-items-end mb-2">
           <MdLocalPrintshop
                          size={26}
                          className="ms-1 text-success"
                             onClick={handleExportExcel}
                          style={{ cursor: "pointer" }}
                          title="Print "
                        />
        </div>

        <div id="exportTable" className='table-responsive bg-white rounded shadow-sm p-3'>
          <table className='table table-bordered table-hover text-center align-middle'>
            <thead className='table-info sticky-top'>
              <tr>
                <th>Code</th>
                <th>Emp Name</th>
                <th>P</th>
                <th>A</th>
                <th>H</th>
                <th>L</th>
                {daysArray.map((day) => <th key={day}>{day}</th>)}
              </tr>
            </thead>
            <tbody>
              {filteredReport.length === 0 ? (
                <tr>
                  <td colSpan={daysArray.length + 6} className='text-center text-muted'>
                    No records found.
                  </td>
                </tr>
              ) : (
                filteredReport.map((emp) => {
                  const { totalP, totalA, totalH, totalL } = daysArray.reduce(
                    (totals, day) => {
                      const info = getAttendanceInfo(day, emp);
                      switch (info.status) {
                        case 'P': totals.totalP++; break;
                        case 'A': totals.totalA++; break;
                        case 'H': totals.totalH++; break;
                        case 'L': totals.totalL++; break;
                        default: break;
                      }
                      return totals;
                    },
                    { totalP: 0, totalA: 0, totalH: 0, totalL: 0 }
                  );

                  return (
                    <tr key={emp.code}>
                      <td>{emp.code}</td>
                      <td className='text-start'>{emp.name}</td>
                      <td className='fw-bold text-success'>{totalP}</td>
                      <td className='fw-bold text-danger'>{totalA}</td>
                      <td className='fw-bold text-primary'>{totalH}</td>
                      <td className='fw-bold text-warning'>{totalL}</td>

                      {daysArray.map((day) => {
                        const info = getAttendanceInfo(day, emp);
                        const statusClass = {
                          P: 'text-success',
                          A: 'text-danger',
                          H: 'text-primary',
                          L: 'text-warning',
                        }[info.status] || '';

                        const showTooltip = info.status === 'P' || info.status === 'H';
                        const tooltipHtml = showTooltip
                          ? `<div><strong>Check-In:</strong> ${info.checkIn}</div>
                             <div><strong>Check-Out:</strong> ${info.checkOut}</div>
                             <div><strong>Worked:</strong> ${info.hours}</div>`
                          : '';

                        return (
                          <td
                            key={day}
                            className={`fw-bold ${statusClass}`}
                            data-bs-toggle={showTooltip ? 'tooltip' : undefined}
                            data-bs-html="true"
                            data-bs-title={tooltipHtml}
                            style={{ cursor: showTooltip ? 'pointer' : 'default' }}
                          >
                            {info.status}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AttReport;